import { CropHandlePosition, getOppositeCorners } from './crop-handle-corner';
import { Point, Region } from './region';

class SnapLine
{
  public readonly slope: number;
  public readonly xOffset: number;
  public readonly yOffset: number;

  constructor(public readonly start: Point, public readonly mid: Point)
  {
    this.slope = (mid.y - start.y) / (mid.x - start.x);
    this.xOffset = start.x;
    this.yOffset = start.y;
  }

  public getClosestIntersection(point: Point): Point {
    const solveY =
        (x: number): number => this.slope * (x - this.xOffset) + this.yOffset;

    const solveX =
        (y: number): number => (y - this.yOffset) / this.slope + this.xOffset;

    const getDistanceToStart =
        (p: Point): number => Math.sqrt(
            (p.x - this.start.x) ** 2 + (p.y - this.start.y) ** 2);

    const xIntersection = new Point(point.x, solveY(point.x));
    const yIntersection = new Point(solveX(point.y), point.y);

    return getDistanceToStart(xIntersection) < getDistanceToStart(yIntersection)
            ? xIntersection
            : yIntersection;
  }
}

export class RegionScaler
{
  public readonly snapLine: SnapLine;
  public readonly oppositePoint: Point;
  public readonly samePoint: Point;

  constructor(
      original: Region,
      private readonly minSize: Region,
      private readonly constrainRegion: Region,
      position: CropHandlePosition)
  {
    const twoPoints = getOppositeCorners(original, position);

    this.snapLine = new SnapLine(twoPoints.opposite, twoPoints.same);
    this.samePoint = twoPoints.same;
    this.oppositePoint = twoPoints.opposite;
  }

  public applyScalePoint(fallback: Region, point: Point): Region
  {
    const pointOnLine = this.snapLine.getClosestIntersection(point);

    if (! this.constrainRegion.containsPoint(pointOnLine) ||
        Math.abs(pointOnLine.x - this.snapLine.start.x) < this.minSize.width ||
        Math.abs(pointOnLine.y - this.snapLine.start.y) < this.minSize.height)
    {
      return fallback;
    }

    return Region.fromTwoPoints(this.snapLine.start, pointOnLine);
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/image-cropper/region-scaler.ts